import 'babel-polyfill';
import 'intersection-observer';
import "lazysizes";
import "picturefill";

// Third party
import AOS from "aos";
import ScrollMagic from 'ScrollMagic';
import 'debug.addIndicators';
import ClipboardJS from 'clipboard';

// Modules
import Menu from "./modules/menu";
import "./modules/contact";
import "./modules/background";
import "./modules/horizontal-scroll";
import "./modules/ie11CustomProperties";
import serviceHeaderAnimation from './modules/service-header-animation';
import './modules/contactForm'
import './modules/global'

window.onload = function () {
    Menu.init();
    new ClipboardJS('.clipboard');

    AOS.init({
        easing: 'ease-out-cubic',
        offset: 100,
        duration: 800,
        once: true, // Only show the animation once.
    });

    serviceHeaderAnimation();

    const animationBlockContainer = document.querySelector('.service__row--text-and-animation-inner div[class*="animation__"');
    if (animationBlockContainer) {
        const scrollController = new ScrollMagic.Controller();

        new ScrollMagic.Scene({
            triggerElement: animationBlockContainer,
            triggerHook: .85,
            reverse: false,
        }).setClassToggle(
            animationBlockContainer.querySelector('svg'),
            'visible',
        ).addTo(scrollController);
    }
};


function toggleCategory() {
    this.classList.toggle('expanded');
}

let categoryToggle = document.getElementById('js-category-toggle');
if (categoryToggle) {
    categoryToggle.addEventListener('click', toggleCategory);
}

const copyToClipboard = document.querySelector('.clipboard');
if (copyToClipboard) {
    copyToClipboard.addEventListener('click', function () {
        copyToClipboard.innerHTML = copyToClipboard.dataset.text;
    });
}
